<template>
    <div id="avatar-wrapper" :style="{ '--height': size + 'px', '--width': size + 'px' }" v-if="targetUser">
        <img
            :src="targetUser.gravatar"
            v-if="targetUser.gravatar"
            id="avatar-img"
            :class="{ offlineBorder: !targetUser.isOnline, onlineBorder: targetUser.isOnline }"
            :style="{ height: size + 'px', width: size + 'px' }"
        />
        <Avatar
            :username="getName()"
            v-else
            id="avatar-placeholder"
            :class="{ offlineBorder: !targetUser.isOnline, onlineBorder: targetUser.isOnline }"
            :style="{ height: size + 'px', width: size + 'px' }"
        />
        <span v-if="targetUser.isOnline" id="online-dot"></span>
        <span v-else id="offline-dot"></span>
        <div
            class="name-container"
            v-tippy="{
                followCursor: true,
                placement: 'bottom-start',
            }"
            :content="targetUser.name"
        >
            <b v-if="isNamed" :style="{ 'font-size': fontSize + 'px' }">{{ targetUser.name }}</b>
        </div>
    </div>
</template>
<script>
import DisplayConfig from "../fast-initialize/DisplayConfig.vue";
import { mapState } from "vuex";
import Avatar from "vue-avatar";

export default {
    name: "AgentAvatar",
    components: { DisplayConfig, Avatar },
    /*props: ["size", "fontSize", "userID", "isNamed"],*/
    props: {
        size: {
            type: Number,
            default: 88,
        },
        fontSize: {
            type: Number,
            default: 20,
        },
        userID: {
            type: String,
            required: true,
            default: "5f9b9b4b4b3b4b4b4b4b4b4b",
        },
        isNamed: {
            type: Boolean,
            default: false,
        },
        singleChar: {
            type: Boolean,
            default: false,
        },
        statusBackgroundColor: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        ...mapState({
            users: (state) => state.user.users.data,
        }),
        targetUser() {
            return this.users.find((user) => user._id === this.userID);
        },
    },
    methods: {
        getName() {
            const targetUser = this.targetUser;
            let name = targetUser.name || "";
            name = this.singleChar ? name.split(" ")[0] : name;
            let slice = this.size < 30 ? 1 : 2;
            return name.split(" ").slice(0,slice).join(" ");
        },
    },
};
</script>
<style lang="scss">
#avatar-wrapper {
    position: relative;
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: 15px;
    width: var(--width);
    height: var(--height);
    min-width: var(--width);
    min-height: var(--height);

    #avatar-img {
        border-radius: 50%;
        height: 100%;
        width: 100%;
        min-height: 109%;
        min-width: 109%;
        object-fit: cover;
    }

    #avatar-placeholder {
        border-radius: 50%;
        height: 100% !important;
        min-height: 109% !important;
        min-width: 109%;
        object-fit: cover;
    }

    #online-dot {
        position: absolute;
        bottom: 7%;
        right: 3%;
        height: 16%;
        width: 16%;
        border-radius: 50%;
        background-color: #009900;
        border: 0.5px solid white;
        /*bottom-right 4px 4px*/
        /*he-wi 13px 13px*/
    }

    #offline-dot {
        position: absolute;
        bottom: 7%;
        right: 3%;
        height: 16%;
        width: 16%;
        border-radius: 50%;
        background-color: #aeaeae;
        border: 0.5px solid white;
    }

    b {
        color: #595959;
    }

    .offlineBorder {
        border: 3px solid #aeaeae;
    }

    .onlineBorder {
        border: 3px solid transparent;
        animation: border-pulsate 2s infinite ease-out;
    }
}

@keyframes border-pulsate {
    0% {
        border-color: rgba(102, 194, 102, 1);
    }
    50% {
        border-color: rgba(255, 255, 255, 1);
    }
    100% {
        border-color: rgba(102, 194, 102, 1);
    }
}
</style>
